// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"1d766657","50":"a613c475","88":"a613c475","486":"98260a15","487":"a51835df","499":"a613c475"}[chunkId] + ".chunk.css";
};